import React from 'react';

/**
 * @typedef {object} AvailableAppraiserListAppraisers
 * @property {number} [ExternalUserId]
 * @property {Object} [UserLicense]
 * @property {Object} [CurrentRole]
 */

/**
 * @typedef {object} AvailableAppraiserListProps
 * @property {string} [title]
 * @property {AvailableAppraiserListAppraisers[]} [appraisers]
 */

/**
 * @param {AvailableAppraiserListProps} props
 */
const AvailableAppraiserList = props => {
  const { title = '', appraisers = [] } = props;

  const renderAppraiserInfo = appraiser => (
    <li key={appraiser.ExternalUserId}>
      {appraiser.CurrentRole.Title} ({appraiser.UserLicense.Name})
    </li>
  );

  return (
    <>
      <span className='bold'>{title}</span>
      <ul>{appraisers.map(appraiser => renderAppraiserInfo(appraiser))}</ul>
    </>
  );
};

export default AvailableAppraiserList;
